module.exports = __webpack_public_path__ + "static/media/account.6bbd7220.svg";